/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const AddDiaryMobile = lazyLoad(
  () => import('./index'),
  module => module.AddDiaryMobile
);
